import { c as _c } from "react/compiler-runtime";
import { MainLayout } from '../MainLayout';
import { PageHeading } from '../layout/PageHeading';
import { PianoIdentity } from '../layout/PianoIdentity';
import { SavedLocallyIndicator } from '../layout/SavedLocallyIndicator';
import { useTranslation } from '@/hooks/use-translation';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../app-ui/tabs';
import { MeasureTab } from '../measures/MeasureTab';
import { MeasureOptionsTab } from '../measures/MeasureOptionsTab';
export const MeasurePage = () => {
  const $ = _c(21);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><PianoIdentity /><SavedLocallyIndicator /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("Measure");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("Measures");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <TabsTrigger value="measures">{t2}</TabsTrigger>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("Options");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <TabsTrigger value="options">{t4}</TabsTrigger>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <TabsList>{t3}{t5}</TabsList>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <PageHeading title={t1} actions={t6} />;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <TabsContent value="measures"><MeasureTab /></TabsContent>;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TabsContent value="options"><MeasureOptionsTab /></TabsContent>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7) {
    t10 = <MainLayout headerRight={t0}><Tabs defaultValue="measures" className="flex flex-col gap-6">{t7}{t8}{t9}</Tabs></MainLayout>;
    $[19] = t7;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};